import script from "./NissinView.vue?vue&type=script&setup=true&lang=js"
export * from "./NissinView.vue?vue&type=script&setup=true&lang=js"

import "./NissinView.vue?vue&type=style&index=0&id=04499b21&lang=css"

const __exports__ = script;

export default __exports__